import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4512500e&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/dragos/Desktop/code/lifturip/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VAvatar } from 'vuetify/lib'
import { VBottomNav } from 'vuetify/lib'
import { VBottomSheet } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VApp,VAvatar,VBottomNav,VBottomSheet,VBtn,VChip,VContent,VIcon,VImg,VList,VListTile,VListTileAction,VListTileContent,VListTileSubTitle,VListTileTitle,VProgressLinear,VSpacer,VSubheader,VToolbar,VToolbarTitle})
